import { LayoutDashboard } from 'lucide-react';
import type { NavigateFunction } from 'react-router-dom';
import type { NavSection } from '@/config/nav';
import type { SyncCommandProvider } from '../types';

export function createPagesProvider(
  navItems: NavSection[],
  navigate: NavigateFunction
): SyncCommandProvider {
  return {
    id: 'shared:pages',
    kind: 'sync',
    label: 'Pages',
    icon: LayoutDashboard,
    priority: 0,
    getItems: () =>
      navItems.flatMap((section) =>
        section.links.map((link) => ({
          id: `page:${link.href}`,
          label: link.label,
          icon: link.icon,
          keywords: [link.href, section.title ?? ''].filter(Boolean),
          onSelect: () => navigate(link.href),
        }))
      ),
  };
}
